/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext} from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


import {Switch, Route, Redirect} from "react-router-dom";
import SettingsMyFavouriteVehiclesPageComponent from "@UIPages/Authenticated/Settings/Favorite/Vehicles";
import SettingsMyFavouriteTerminalsPageComponent from "@UIPages/Authenticated/Settings/Favorite/Terminals";


type SettingsPageFavoriteViewProps = {};


export const SettingsPageFavoriteViewComponent: React.FC<SettingsPageFavoriteViewProps> = (): JSX.Element | null => {


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;

    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return null;

    if (!ROUTER) return <Redirect to={"/404"} />;


    const SETTINGS_PAGE_URLS = ROUTER.AUTHENTICATED.SETTINGS;

    const {
        MAIN_PAGE,
        SETTINGS_MY_FAVORITE_VEHICLES_PAGE,
        SETTINGS_MY_FAVORITE_TERMINALS_PAGE,
    } = SETTINGS_PAGE_URLS;


    return (
        <Switch>

            <Route
                path={SETTINGS_MY_FAVORITE_VEHICLES_PAGE.URL} exact
                render={() =>
                    <SettingsMyFavouriteVehiclesPageComponent />
                }
            />

            <Route
                path={SETTINGS_MY_FAVORITE_TERMINALS_PAGE.URL} exact
                render={() =>
                    <SettingsMyFavouriteTerminalsPageComponent />
                }
            />

            <Redirect to={MAIN_PAGE.URL} />

        </Switch>
    );

};


export default SettingsPageFavoriteViewComponent;
